import type {
    ICreateRentRollVersionParams,
    ICreateRentRollsParams,
    IFindRentRollVersionsParams,
    IRentRoll,
    IRentRollDataSource,
    IRentRollImportResult,
    IRentRollVersion,
    IUpdateRentRollParams,
    IUpdateRentRollVersionParams,
    RentRollVersionEvents,
    RentRollVersionExpandOpts,
} from '@condo/domain';
import { type ICockpitAxiosRequestConfig, getClient } from '../api-client';

const skipErrorHandler: ICockpitAxiosRequestConfig = { skipErrorHandler: true };

export const fetchRentRollVersion = async (rentRollVersionId: number, expand: RentRollVersionExpandOpts): Promise<IRentRollVersion> =>
    getClient('basecamp')
        .get<{ rentRollVersion: IRentRollVersion }>(`/rent-roll-versions/${rentRollVersionId}`, { params: { expand } })
        .then(response => response.data.rentRollVersion);

export const fetchRentRollVersions = async (query: IFindRentRollVersionsParams['query'], expand: RentRollVersionExpandOpts): Promise<IRentRollVersion[]> =>
    getClient('basecamp')
        .get('rent-roll-versions', { params: { ...query, expand } })
        .then(response => response.data.rentRollVersions);

export const createRentRollVersion = async (data: ICreateRentRollVersionParams): Promise<IRentRollImportResult> =>
    getClient('basecamp')
        .post<IRentRollImportResult>('/rent-roll-versions', data, { ...skipErrorHandler, params: { dryRun: data.dryRun } })
        .then(response => response.data);

export const createRentRolls = async (data: ICreateRentRollsParams): Promise<IRentRoll[]> =>
    getClient('basecamp')
        .post<{ rentRolls: IRentRoll[] }>(`/rent-roll-versions/${data.rentRollVersionId}/rent-rolls`, { rentRolls: data.rentRolls })
        .then(response => response.data.rentRolls);

export const updateRentRollVersion = async (rentRollVersionId: number, data: IUpdateRentRollVersionParams['data']): Promise<void> =>
    getClient('basecamp').put(`/rent-roll-versions/${rentRollVersionId}`, { data });

export const updateRentRoll = async (rentRollId: number, data: IUpdateRentRollParams['data']): Promise<void> =>
    getClient('basecamp').put(`/rent-rolls/${rentRollId}`, { data });

export const deleteRentRolls = async (rentRollIds: number[]): Promise<void> => getClient('basecamp').post('/rent-rolls/delete', { rentRollIds });

export const processRentRollVersionEvent = async ({ rentRollVersionId, event }: { rentRollVersionId: number; event: RentRollVersionEvents }): Promise<{}> =>
    getClient('basecamp').post(`/rent-roll-versions/${rentRollVersionId}/event`, { event });

export const replaceRentRollVersionData = async (rentRollVersionId: number, source: IRentRollDataSource): Promise<IRentRollImportResult> =>
    getClient('basecamp')
        .put<IRentRollImportResult>(`/rent-roll-versions/${rentRollVersionId}/replace-data`, { source })
        .then(response => response.data);

export const deleteRentRollVersion = async (rentRollVersionId: number): Promise<void> =>
    getClient('basecamp').delete(`/rent-roll-versions/${rentRollVersionId}`);
